import * as angular from "angular";
import {IController} from "angular";
import {AccountModel} from "../../angular/models/account.model";

export class SupplyAccountCommissionsLinkCtrl implements IController {
  account: AccountModel;
}

angular
  .module('bringoz.admin.accounts')
  .component('supplyAccountCommissionsLink', {
    bindings: {
      account: '<'
    },
    template: require('./supply-account-commissions-link.html').default,
    controller: SupplyAccountCommissionsLinkCtrl
  });
